import { queryKeys } from '@/lib/queryKeys';
import { consentApi } from '@/services/api';
import { useQuery } from '@tanstack/react-query';

export function useConsentPurposes(
  filters?: { is_active?: boolean },
  options?: {
    enabled?: boolean;
    staleTime?: number;
    refetchOnWindowFocus?: boolean;
  }
) {
  return useQuery({
    queryKey: queryKeys.consentPurposes.list(filters),
    queryFn: () => consentApi.getPurposes(),
    staleTime: 5 * 60 * 1000, // 5 minutes
    ...options,
  });
}

export function useActiveConsentPurposes(options?: {
  enabled?: boolean;
  staleTime?: number;
  refetchOnWindowFocus?: boolean;
}) {
  return useConsentPurposes({ is_active: true }, options);
}
